// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_je6cB{--buttonsTopMargin:0}@media only screen and (min-width:768px){.root_je6cB{--buttonsTopMargin:-50px}}.root_je6cB{position:absolute;top:0;left:0;right:0;display:flex;justify-content:flex-end;padding-top:15px;pointer-events:none;z-index:2}.buttons_q8WH1{margin-top:var(--buttonsTopMargin);padding:0 10px}.button_KKp0T{display:flex;justify-content:center;align-items:center;margin:0 5px;width:50px;height:50px;border-radius:50%;background:#fff;box-shadow:0 4px 6px rgba(0,0,0,.2);cursor:pointer;pointer-events:all}.buttonIcon_dlfDG{width:22px;height:22px}.buttonIcon_dlfDG.favorite_BD8sU{color:#7123d9}", ""]);
// Exports
exports.locals = {
	"root": "root_je6cB",
	"buttons": "buttons_q8WH1",
	"button": "button_KKp0T",
	"buttonIcon": "buttonIcon_dlfDG",
	"favorite": "favorite_BD8sU"
};
module.exports = exports;
